export const AMPLITUDE_PROD_KEY = "bfab5ebd98e33df93e8a8a5acf8d2f8f";
export const AMPLITUDE_DEV_KEY = "62046cf6dfa40221e9de804a6285b780";
